export const tabIndex = (contentCode: string | undefined) => {
  if(contentCode?.includes('internal_messages')){
    return 3
  } else {
    return 0
  }
}
